module.exports = __webpack_public_path__ + "static/media/single.468fc124.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/single.png
// module id = 346
// module chunks = 0